import { createApiClient } from './apiClient';
import { API_BASE_URL } from '../config';

type DashboardResponse = {
  success: boolean;
  data?: DashboardUser[];
  message?: string;
};

export type DashboardUser = {
  tg_chat_id: number;
  username: string;
  auto_trading?: boolean;
  valid_till?: string;
  satoshiPlanName?: string;
};

const dashboardApi = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function fetchDashboard(token: string | null): Promise<DashboardResponse> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await dashboardApi.get<DashboardResponse>('/dashboard', { headers });
  return resp.data;
}
